export const showGameStateForEvent = (ids, sportId) => ids.find(id => id === sportId) ? true : false;
//# sourceMappingURL=showGameStateForEvent.js.map